import { useHideOn } from '../../utils/contexts/ResponsiveProvider'

const HideOn = ({ children, hideOn }) => {
  if (useHideOn(hideOn)) return false
  return children
}

export default HideOn
